import styled, { css } from 'styled-components';
import { images } from '../../../Constants/ImageUrls';

export const IVFCarouselWrapper = styled.div`
  // padding: 122px 0 0;

  .headerImage {
    width: 100%;
    margin-bottom: -10px;
  }

  ${(props) =>
    props.StoreHome
      ? 'padding-top:170px !important'
      : props.clothDiaperPage
        ? 'padding-top:3% !important'
        : props.isParentingPage
          ? 'padding-top:8% !important'
          : ''};
  ${(props) =>
    props.fullWidth
      ? css`
          width: 100%;
          margin: auto;
        `
      : css`
          width: 80%;
          margin: auto;
        `} @media (
    max-width: 720px) {
    margin-top: ${(props) => (props.isForJoyfulPage ? '16px' : '')};
    padding: ${(props) =>
      props.noMobileCategory
        ? '0 0 0 0'
        : props.clothDiaperPage || props.isParentingPage
          ? '0 !important'
          : ' 0 0'};
    width: 100%;
    ${(props) =>
      props.StoreHome
        ? 'padding-top:32px !important'
        : // : props.lactoMama
          // ? "padding-top:51px !important"
          ''};
  }

  @media (min-width: 720px) {
    ${(props) =>
      props.lactoMamaCategory ? 'padding-top:51px !important' : ''};
  }

  margin-top: ${(props) => (props.stretchMarksPage ? '20px' : '')};
`;

export const DiaperWrapper = styled.div`
  @media (max-width: 720px) {
    padding-top: ${(props) =>
      props.isForNewCdPage
        ? '65px'
        : props.catHideHeader
          ? '0'
          : !props.userType
            ? '65px'
            : '118px'};
  }
  // @media (min-width: 720px) {
  //         display: flex;
  //         flex-direction: column;
  //         justify-content: center;
  //         align-items: center;
  //         max-width: 1050px;
  //         margin: 0px auto;
  // }
  padding-top: 90px;
`;

export const CarouselImage = styled.img`
  height: auto;
  width: 100%;
  max-width: ${(props) => (props.testimonial ? '400px' : '100%')};
  width: ${(props) => (props.testimonial ? '400px' : '')};
  @media (max-width: 720px) {
    border-radius: 0;
    max-width: ${(props) => (props.testimonial ? '240px' : '100%')};
  }
`;
export const CarouselImageDiv = styled.div`
  height: auto;
  width: 100%;
  width: ${(props) => (props.testimonial ? '400px' : '100%')};

  div,
  span {
    position: unset !important;
  }

  .image {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }

  img {
    background: url(${(props) =>
        props.placeholderImageMobile || images.defaultImage})
      center center no-repeat;
    background-size: cover;

    @media (min-width: 720px) {
      background: url(${(props) =>
          props.placeholderImageDesktop || images.defaultImage})
        center center no-repeat;
    }
  }

  @media (max-width: 720px) {
    border-radius: 0;
    width: ${(props) => (props.testimonial ? '240px' : '100%')};
  }

  .carousel-desktop {
    @media (max-width: 720px) {
      display: none !important;
    }
  }

  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }
`;

export const CarouselArrow = styled.img`
  width: 22px;
  transform: ${(props) =>
    props.right
      ? 'rotate(270deg) translate(-50%, 36px)'
      : 'rotate(90deg) translate(-50%, 36px)'};
  position: absolute;
  top: 46%;
  right: ${(props) => props.right};
  cursor: pointer;
  z-index: 9;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const IVFCarouselCSS = styled.div`
    background: ${(props) => (props.color ? props.color : '#fff')};
    position: relative;

    .expertHeading {
        padding: 6px 16px 16px;
        text-transform: uppercase;
        font-size: 15px;
        font-weight: 500;
        opacity: 0.87;
    }

    .experHeadingResults {
        font-size: clamp(20px, 2vw, 22px);
        font-weight: 600;
        color: rgba(0, 0, 0, 0.87);
        padding: 10px 16px;
        margin-bottom: 12px;
        text-transform: capitalize;
    }

    .customArrow {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        width: 40px !important;
        pointer-events: all !important;

        &.leftArr {
            left: 8px;
            right: unset;
            z-index: 1;
        }

        &.lowOpacity {
            opacity: 0.4;
        }

        &.disabled {
            opacity: 0;
            pointer-events: none !important;
        }
    }

    @media (max-width: 720px) {
        ${(props) =>
          props.isForNewCdPage || props.lactoMamaCategory
            ? css`
                .slider-wrapper {
                  ul {
                    height: 350px;
                  }
                }
              `
            : null}
    }

    &.heroSection {
        display: flex;
        flex-direction: column;
        background-color: #fef9f9;

        .hero_section_text {
            padding: 0em 1em 1em;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 55%;
                @media (max-width: 720px) {
                    width: 70%;
                }
            }

            @media (max-width: 720px) {
                justify-content: flex-start;
                align-items: flex-start;

                padding: 24px 16px 24px;
            }

            .hero_section_heading {
                position: relative;
                color: #ef4e5e;
                font-size: clamp(20px, 2vw, 30px);
                font-weight: 600;
                letter-spacing: 2px;
            }

            .hero_section_description {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 16px;

                p {
                    font-size: clamp(13px, 2vw, 18px);
                    font-weight: 400;
                    line-height: 28px;
                    color: #000;
                    @media (max-width: 768px) {
                        line-height: 24px;
                    }
                }

                @media (max-width: 768px) {
                    margin-top: 16px;
                    align-items: flex-start;
                }
            }
        }

        .hero_carousel {
            flex-basis: 100%;
        }

        .hero_carousel .carousel .control-dots {
            bottom: 0 !important;
            d
        }
    }

    & .carousel .control-arrow,
    .carousel.carousel-slider .control-arrow {
        -webkit-transition: all 0.25s ease-in;
        -moz-transition: all 0.25s ease-in;
        -ms-transition: all 0.25s ease-in;
        -o-transition: all 0.25s ease-in;
        transition: all 0.25s ease-in;
        opacity: 0.4;
        filter: alpha(opacity=40);
        position: absolute;
        z-index: 2;
        top: 20px;
        background: none;
        border: 0;
        font-size: 32px;
        cursor: pointer;
    }

    & .carousel .control-arrow:hover {
        opacity: 1;
        filter: alpha(opacity=100);
    }

    & .carousel .control-arrow:before,
    & .carousel.carousel-slider .control-arrow:before {
        margin: 0 5px;
        display: inline-block;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        content: "";
    }

    & .carousel .control-disabled.control-arrow {
        opacity: 0;

        .carousel.carousel-slider .control-arrow:hover
        filter:

    alpha(opacity = 0);
        cursor: inherit;
        display: none;
    }

    & .carousel .control-prev.control-arrow {
        left: 0;
    }

    & .carousel .control-prev.control-arrow:before {
        border-right: 8px solid #fff;
    }

    & .carousel .control-next.control-arrow {
        right: 0;
    }

    & .carousel .control-next.control-arrow:before {
        border-left: 8px solid #fff;
    }

    & .carousel-root {
        outline: none;
    }

    & .carousel {
        position: relative;
        width: 100%;

        .carousel-desktop {
            @media (max-width: 720px) {
                display: none !important;
            }
        }

        .carousel-mobile {
            display: none !important;
            @media (max-width: 720px) {
                display: block !important;
            }
        }
    }

    & .carousel * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    & .carousel img {
        width: 100%;
        height: auto;
        display: inline-block;
        pointer-events: none;
    }

    & .carousel .carousel {
        position: relative;
    }

    & .carousel .control-arrow {
        outline: 0;
        border: 0;
        background: none;
        top: 50%;
        margin-top: -13px;
        font-size: 18px;
    }

    & .carousel .thumbs-wrapper {
        margin: 20px;
        overflow: hidden;
    }

    & .carousel .thumbs {
        -webkit-transition: all 0.15s ease-in;
        -moz-transition: all 0.15s ease-in;
        -ms-transition: all 0.15s ease-in;
        -o-transition: all 0.15s ease-in;
        transition: all 0.15s ease-in;
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        -ms-transform: translate3d(0, 0, 0);
        -o-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        position: relative;
        list-style: none;
        white-space: nowrap;
    }

    & .carousel .thumb {
        -webkit-transition: border 0.15s ease-in;
        -moz-transition: border 0.15s ease-in;
        -ms-transition: border 0.15s ease-in;
        -o-transition: border 0.15s ease-in;
        transition: border 0.15s ease-in;
        display: inline-block;
        margin-right: 6px;
        white-space: nowrap;
        overflow: hidden;
        border: 3px solid #fff;
        padding: 2px;
    }

    & .carousel .thumb:focus {
        border: 3px solid #ccc;
        outline: none;
    }

    & .carousel .thumb.selected,
    .carousel .thumb:hover {
        border: 3px solid #333;
    }

    & .carousel .thumb img {
        vertical-align: top;
    }

    & .carousel.carousel-slider {
        position: relative;
        margin: 0;
        ${(props) =>
          props.hideMargin
            ? ` `
            : props.happiness
              ? `margin-bottom: 16px`
              : ` margin-bottom: 39px;
        @media (min-width: 720px) {
            margin-bottom: 50px;
        }
`}

    }

    & .carousel.carousel-slider .control-arrow {
        top: 0;
        color: #fff;
        font-size: 26px;
        bottom: 0;
        margin-top: 0;
        padding: 5px;
    }

    & .carousel.carousel-slider .control-arrow:hover {
        @media (min-width: 720px) {
            background: rgba(0, 0, 0, 0.2);
        }
    }

    & .carousel .slider-wrapper {
        overflow: hidden;
        margin: auto;
        width: 100%;
        -webkit-transition: height 0.15s ease-in;
        -moz-transition: height 0.15s ease-in;
        -ms-transition: height 0.15s ease-in;
        -o-transition: height 0.15s ease-in;
        transition: height 0.15s ease-in;
    }

    & .carousel .slider-wrapper.axis-horizontal .slider {
        -ms-box-orient: horizontal;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -moz-flex;
        display: -webkit-flex;
        display: flex;
        ${(props) =>
          props.isDesktopShow
            ? css`
                column-gap: 1%;
              `
            : null}
    }

    & .carousel .slider-wrapper.axis-horizontal .slider .slide {
        flex-direction: column;
        flex-flow: column;

        .anchorBlock {
            position: relative;
            display: block;
            padding-top: ${(props) =>
              props.StoreHome
                ? '27%'
                : props.clothDiaperPage
                  ? '22.3%'
                  : props.imageRatioDesktop || '25%'};
            @media (max-width: 720px) {
                padding-top: ${(props) =>
                  props.milkBankTool
                    ? '36.5%'
                    : props.clothDiaperPage
                      ? '66.67%'
                      : props.happiness
                        ? '107%'
                        : props.StoreHome
                          ? '100%'
                          : props.imageRatioMobile || '82.5%'};
            }
        }

        .anchorBlockHeroSection {
            position: relative;
            display: block;
            padding-top: 25%;
            @media (max-width: 720px) {
                padding-top: 75%;
            }
        }
    }

    & .carousel .slider-wrapper.axis-vertical {
        -ms-box-orient: horizontal;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -moz-flex;
        display: -webkit-flex;
        display: flex;
    }

    & .carousel .slider-wrapper.axis-vertical .slider {
        -webkit-flex-direction: column;
        flex-direction: column;
    }

    & .carousel .slider {
        margin: 0;
        padding: 0;
        position: relative;
        list-style: none;
        width: 100%;
    }

    & .carousel .slider.animated {
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
        @media (min-width: 720px) {
            ${(props) => (props.showSmallView ? 'height: 420px' : '')}
        }
    }

    & .carousel .slide {
        min-width: 100%;
        margin: 0;
        text-align: center;

        ${(props) =>
          props.customSlideClass ? props.customSlideClass : 'div'} {
            background: ${(props) =>
              props.fromStage
                ? ''
                : 'url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp)'};
            background-size: cover;
            background-repeat: no-repeat;
            height: 100%;
            background-position: 50%;
            border-radius: 8px;
            cursor: pointer;

            @media (max-width: 720px) {
                cursor: default;
                border-radius: 0;
            }
        }
    }

    & .carousel .slide img {
        width: 100%;
        height: auto;
        vertical-align: top;
        border: 0;
    }

    & .carousel .slide iframe {
        display: inline-block;
        width: calc(100% - 80px);
        margin: 0 40px 40px;
        border: 0;
    }

    & .carousel .slide .legend {
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -ms-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
        position: absolute;
        bottom: 40px;
        left: 50%;
        margin-left: -45%;
        width: 90%;
        border-radius: 10px;
        background: #000;
        color: #fff;
        padding: 10px;
        font-size: 12px;
        text-align: center;
        opacity: 0.25;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;
    }

    & .carousel .control-dots {
        position: absolute;
            // bottom: ${(props) => (props.clothDiaperPage ? '-6px' : '-36px')};
        margin: 10px 0;
        padding: 0;
        text-align: center;
        width: 100%;
        z-index: 9;
        top: 100%;
        @media (min-width: 768px) {
            display: ${(props) => (props.isResultPage ? 'none' : 'block')};
        }
    }

    & .carousel .control-dots .dot {
        transition: all 0.25s ease-in;
        filter: alpha(opacity=30);
        background: hsl(0deg, 0%, 0%, 50%);
        border-radius: 50%;
        width: clamp(8px, 2vw, 9px);
        height: clamp(8px, 2vw, 9px);
        cursor: pointer;
        display: inline-block;
        margin: 0 5px;
        opacity: 0.8;
    }

    & .carousel .control-dots .dot.selected {
        opacity: 1;
        filter: alpha(opacity=100);
        background: #ef4e5e;
        width: 18px;
        border-radius: 10px;
    }

    & .carousel .carousel-status {
        position: absolute;
        top: 0;
        right: 0;
        padding: 5px;
        font-size: 10px;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
        color: #fff;
    }

    & .carousel:hover .slide .legend {
        opacity: 1;
    }
`;
